import axios from "axios";

export const saveWorkflow = (workflow, data) => {
  let method, url;
  if (workflow) {
    method = "patch";
    url = `/api/enrollment_builder/workflows/${workflow.id}`;
  } else {
    method = "post";
    url = "/api/enrollment_builder/workflows";
  }

  return axios({
    method: method,
    data: data,
    url: url,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};


export function fetchWorkflows(view = "recruiter") {
  return axios({
    method: "get",
    url: `/api/enrollment_builder/workflows?view=${view}`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      throw err;
    });
}

export function deleteWorkflow(workflowId) {
  return axios({
    method: "delete",
    url: `/api/enrollment_builder/workflows/${workflowId}`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}

export function createStep(workflowId, data) {
  const { custom_fields, deletedCustomFields, ...filteredData } = data;

  return axios({
    method: "post",
    url: `/api/enrollment_builder/workflows/${workflowId}/steps`,
    data: {
      step: {
        ...filteredData,
        label: filteredData.label || filteredData.name,
        custom_fields_attributes: custom_fields?.map(field => ({
          name: field.name,
          label: field.name,
          field_type: field.field_type,
          description: field.description
        })) || []
      }
    },
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}

export function updateStep(stepId, data) {
  return axios({
    method: "patch",
    url: `/api/enrollment_builder/steps/${stepId}`,
    data: { step: data },
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}

export function fetchDocumentDescriptors() {
  return axios({
    method: "get",
    url: "/api/document_descriptors",
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}

export function fetchWorkflowSteps(workflowId) {
  return axios({
    method: "get",
    url: `/api/enrollment_builder/workflows/${workflowId}/steps`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => {
      return response.data.map(step => ({
        ...step,
        custom_fields: step.custom_fields || []
      }));
    })
    .catch(err => {
      throw err;
    });
}

export function deleteStep(stepId) {
  return axios({
    method: "delete",
    url: `/api/enrollment_builder/steps/${stepId}`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}

export function fetchMappingByRecruiterId(recruiterWorkflowId) {
  return axios({
    method: "get",
    url: `/api/enrollment_builder/mappings?recruiter_workflow_id=${recruiterWorkflowId}`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => {
      const mapping = response.data.find(m => m.recruiter_workflow_id === recruiterWorkflowId);

      if (!mapping) {
        return null;
      }

      return axios.all([
        axios.get(`/api/enrollment_builder/workflows/${mapping.recruiter_workflow_id}`),
        axios.get(`/api/enrollment_builder/workflows/${mapping.candidate_workflow_id}`)
      ]).then(axios.spread((recruiter, candidate) => {
        return {
          ...mapping,
          recruiter_workflow: recruiter.data,
          candidate_workflow: candidate.data
        };
      }));
    })
    .catch(err => {
      throw err;
    });
}


export function fetchCandidateWorkflows() {
  return axios({
    method: "get",
    url: "/api/enrollment_builder/workflows?view=candidate",
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}


export const saveMappedStep = (mappingId, mappedStep, data) => {
  let method, url;
  if (mappedStep) {
    method = "patch";
    url = `/api/enrollment_builder/mapped_steps/${mappedStep.id}`;
  } else {
    method = "post";
    url = `/api/enrollment_builder/mappings/${mappingId}/mapped_steps`;
  }

  return axios({
    method: method,
    data: data,
    url: url,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

export function fetchMappedSteps(mappingId) {
  if (!mappingId) {
    return Promise.reject("mappingId es requerido");
  }

  return axios({
    method: "get",
    url: `/api/enrollment_builder/mappings/${mappingId}/mapped_steps`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
}

export function deleteMappedStep(mappingId, mappedStepId) {
  axios({
    method: "delete",
    url: `/api/enrollment_builder/mappings/${mappingId}/mapped_steps/${mappedStepId}`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      throw err;
    });
}
